import React, { useState } from 'react'
import { GoPlus } from 'react-icons/go'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createIssue, getVolumes } from '../../../../entity/volumes/Volumes'
import CreateIssueModal from '../../../../components/CreateIssueModal/CreateIssueModal'

const CreateIssue = ({ volumeId, data }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const createIssueHandler = async data => {
    console.log('🚀 ~ createIssueHandler ~ data:', data)
    if (volumeId && data) {
      const res = await dispatch(createIssue({ volumeId, issueData: data }))

      if (createIssue?.fulfilled?.match(res)) {
        dispatch(getVolumes())
        if (res?.payload?.id) {
          history.push(`/volumes/${volumeId}/issue/${res?.payload?.id}`)
        }
      } else if (createIssue.rejected.match(res)) {
        console.error('Error creating issue:', res.payload || res.error.message)
      }
    }
    modalHandler()
  }

  return (
    <>
      <GoPlus
        className='hover:cursor-pointer hover:scale-105 transition-all'
        onClick={modalHandler}
      />
      {isOpen && (
        <CreateIssueModal isOpen={isOpen} onClose={modalHandler} onSubmit={createIssueHandler} />
      )}
    </>
  )
}

export default CreateIssue
